import ToolbarButton from '../components/ToolbarButton';

const Indent = () => (
  <>
    <ToolbarButton
      className="ql-indent"
      value="-1"
      text={__('Decrease indent')}
      iconName="indent"
      iconProps={{
        rotation: 180,
      }}
      data-testid="toolbar-decrease-indent"
    />
    <ToolbarButton
      className="ql-indent"
      value="+1"
      text={__('Increase indent')}
      iconName="indent"
      data-testid="toolbar-increase-indent"
    />
  </>
);

export default Indent;
